module.exports = __webpack_public_path__ + "assets/11f92dc119a5b52ad480a474ffea596b.jpg";